/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { SelectField, SelectWrapper, Arrow, FieldError } from './style'

type CustomSelectPtops = {
    label: string
    value: string
    options?: { value: string; label: string }[]
    name: string
    onChange: React.ChangeEventHandler<HTMLSelectElement>
    onBlur: React.FocusEventHandler<HTMLSelectElement>
    error?: string
}

export const CustomSelect = ({ label, options, name, onChange, onBlur, value, error = '' }: CustomSelectPtops) => (
    <>
        <SelectWrapper>
            <SelectField error={!!error} isEmpty={!value} name={name} onBlur={onBlur} onChange={onChange} value={value}>
                <option disabled style={{ display: 'none' }} value="" />
                {(options ?? []).map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </SelectField>
            <Arrow error={error} />
            <label className="select-label">{label}</label>
            {error && (
                <FieldError>
                    <span>{error}</span>
                </FieldError>
            )}
        </SelectWrapper>
    </>
)
